<template>
  <v-row>
    <v-dialog v-model="moment" width="800">
      <v-row align="center" justify="center">
        <v-col
          lg="12"
          sm="12"
          md="12"
          cols="12"
          xl="12"
          xs="12"
          class="text-center"
          ><h1 style="font-size: 48px">
            <span style="color: #3F44A3">Kan</span>
            <span style="color: #4A98B2">Pramool</span>
          </h1>
        </v-col>
        <v-col class="text-center" sm="10" md="6" cols="8" xl="3" xs="10" lg="3"
          ><v-progress-linear
            color="#F8F364"
            indeterminate
            rounded
            height="6"
          ></v-progress-linear
        ></v-col>
      </v-row>
    </v-dialog>
    <v-dialog v-model="dialogtuser" persistent max-width="60%">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          style="font-family: 'Kanit', sans-serif "
          >แก้ไขข้อมูลพนักงาน</v-card-title
        >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  dense
                  label="ชื่อพนักงาน"
                  type="text"
                  v-model="form.fullname"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  dense
                  label="E-mail พนักงาน"
                  type="text"
                  v-model="form.email"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  dense
                  label="username"
                  type="text"
                  v-model="form.username"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-text-field
                  dense
                  label="password"
                  type="password"
                  v-model="form.password"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="form.role"
                  :items="items"
                  :rules="[(v) => !!v || 'Item is required']"
                  label="Item"
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="update()">
            <v-icon light style="color: #fff">mdi-content-save-outline</v-icon>
            <span style="color: #fff">อัพเดทข้อมูล</span>
          </v-btn>
          <v-btn color="red" @click="cancelScreen()">
            <v-icon light style="color: #fff">mdi-close-octagon</v-icon>
            <span style="color: #fff">ปิดหน้าจอ</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-col
      cols="12"
      sm="11"
      md="11"
      style="padding-top: 80px; padding-left: 10%;"
    >
      <v-card>
        <v-card-title>
          ข้อมูล User
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="ค้นหาข้อมูล"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="torUser"
          :search="search"
          style="padding-bottom: 50px;"
        >
          <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" @click="editItem(item)">
              mdi-pencil
            </v-icon>
          </template>
          <template v-slot:item.expenditure="{ item }">
            {{
              item.expenditure
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}
          </template>
        </v-data-table>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import md5 from "crypto-js/md5";
import axios from "axios";
export default {
  data() {
    return {
      items: ["Operation", "Staff", "Admin"],
      select: null,
      checkHightDisplay: "",
      dialogtuser: false,
      display: false,
      heightDisplay: null,
      moment: false,
      typeOfWork: [],

      dialogtor: false,
      search: "",
      torUser: [],
      districtss: [],
      form: {
        id: null,
        fullname: null,
        email: null,
        username: null,
        password: null,
        role: null,
        password_md5: null,
      },
      headers: [
        { text: "E-Mail ผู้ใช้งาน", value: "email" },
        {
          text: "ชื่อพนักงาน",
          align: "start",
          value: "fullname",
        },
        { text: "Username", value: "username", width: "25%" },

        { text: "ตำเเหน่งพนักงาน", value: "role" },
        { text: "Actions", value: "actions", sortable: false, width: "5%" },
      ],
      torProject: [],
    };
  },
  mounted() {
    if (localStorage.getItem("username") !== null) {
      if (localStorage.getItem("role") !== "Admin") {
        alert("คุณไม่มีสิทธิ์เข้าถึงหน้านี้");
        this.$router.push("/login");
      }
      //----------
    }
    axios.get(this.api + "/get/tor_users").then((res) => {
      this.torUser = [];
      this.torUser = res.data.response;
    });

    // this.$axios
    //   .post(this.api + "/checkversion", { version: this.version.split(" ")[3] })
    //   .then((res) => {
    //     if (!res.data.status) {
    //       alert("เวอรันที่ใช้งานไม่ตรงกับเวอร์ชันปัจจุบัน");
    //       location.reload();
    //     }
    //   });
    if (localStorage.getItem("username") === undefined) {
      alert("กรุณาลงชื่อเข้าสู่ระบบก่อน");
      this.$router.push("/login");
    }
  },
  methods: {
    cancelScreen() {
      this.dialogtuser = false;
    },
    editItem(item) {
      this.dialogtuser = true;
      this.form.id = item.id;
      this.form.email = item.email;
      this.form.fullname = item.fullname;
      this.form.password = item.password;
      this.form.role = item.role;
      this.form.username = item.username;
    },
    update() {
      let md5Hash = md5(this.form.password);
      this.form.password_md5 = md5Hash.toString();
      axios.post(this.api + "/update/tor_users", this.form).then((res) => {
        if (res.data.status) {
          this.dialogtor = false;
          alert("บันทึกข้อมูลเรียบร้อย");
          location.reload();
        } else {
          alert("เกิดความผิดพลาดในการบันทึก");
        }
      });
      this.dialog = false;
    },
  },
};
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Kanit&display=swap");
</style>
